var _line, _line2, _line3, _line4, _line5, _line6, _line7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.7002,
    y1: 1.31543,
    x2: 5.7002,
    y2: 16.2237,
    stroke: "black",
    strokeWidth: 2.63087,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23.2393,
    y1: 1.31543,
    x2: 23.2393,
    y2: 16.2237,
    stroke: "black",
    strokeWidth: 2.63087,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1.31543,
    y1: 4.82325,
    x2: 1.31543,
    y2: 12.7158,
    stroke: "black",
    strokeWidth: 2.63087,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 18.8545,
    y1: 4.82325,
    x2: 18.8545,
    y2: 12.7158,
    stroke: "black",
    strokeWidth: 2.63087,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 10.085,
    y1: 6.57715,
    x2: 10.085,
    y2: 10.9619,
    stroke: "black",
    strokeWidth: 2.63087,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 27.624,
    y1: 6.57715,
    x2: 27.624,
    y2: 10.9619,
    stroke: "black",
    strokeWidth: 2.63087,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 14.4697,
    y1: 7.4541,
    x2: 14.4697,
    y2: 10.085,
    stroke: "black",
    strokeWidth: 2.63087,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundWave);
export default __webpack_public_path__ + "static/media/SoundWave.3e2bd8369852ae55df3937f78c4c124d.svg";
export { ForwardRef as ReactComponent };